export default "__VITE_ASSET__aM1BjGfD__"